// extracted by mini-css-extract-plugin
module.exports = {"newDeck":"NewDeck_newDeck_1y4i5","newDeck__title":"NewDeck_newDeck__title_HwylQ","newDeck__input":"NewDeck_newDeck__input_2Ckbo"};